package co.maytes.standupbot.dashboard.components.motion

enum class ViewPhase { Loading, Error, Empty, Ready }
